export const getDecimalSign = (locales: string | string[]) => {
  const { format } = new Intl.NumberFormat(locales)
  const [, decimalSign] = /^0(.)1$/.exec(format(0.1)) || []

  return decimalSign
}
